import { render, staticRenderFns } from "./GalileoInertialViz.vue?vue&type=template&id=64a07dbc&scoped=true"
import script from "./GalileoInertialViz.vue?vue&type=script&lang=js"
export * from "./GalileoInertialViz.vue?vue&type=script&lang=js"
import style0 from "./GalileoInertialViz.vue?vue&type=style&index=0&id=64a07dbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a07dbc",
  null
  
)

export default component.exports